import { ChangeDetectionStrategy, Component } from '@angular/core';
import {RouterLink} from "@angular/router";
import {ProgressSpinner} from "primeng/progressspinner";

@Component({
  selector: 'homey-waiting-for-federated-auth',
  imports: [
    RouterLink,
    ProgressSpinner
  ],
  templateUrl: './waiting-for-federated-auth.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WaitingForFederatedAuthComponent {

}
